var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!this.loading)?[_c('Banner'),_c('div',{staticClass:"containerBodyApp"},[_c('Export_document',{attrs:{"response":_vm.response}}),_c('Side_bar')],1)]:_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100vh"}},[_c('div',{staticClass:"loader"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }